import { valueOf } from "@/modules/irohana-components/types/common";

export const SORTING = {
  ASC: "ASC",
  DESC: "DESC",
};

export type TSorting = valueOf<typeof SORTING>;
